import { render } from "./ExcavationDimensionFields.vue?vue&type=template&id=2c51c453&scoped=true"
import script from "./ExcavationDimensionFields.vue?vue&type=script&lang=js"
export * from "./ExcavationDimensionFields.vue?vue&type=script&lang=js"

import "./ExcavationDimensionFields.vue?vue&type=style&index=0&id=2c51c453&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c51c453"]])

export default __exports__